import { render, staticRenderFns } from "./LetterOfWishesCard.vue?vue&type=template&id=57c2bed8&scoped=true"
import script from "./LetterOfWishesCard.vue?vue&type=script&lang=js"
export * from "./LetterOfWishesCard.vue?vue&type=script&lang=js"
import style0 from "./LetterOfWishesCard.vue?vue&type=style&index=0&id=57c2bed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c2bed8",
  null
  
)

export default component.exports